import React from 'react';

interface BaseLayoutProps {
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  enableSafeArea?: boolean;
  backgroundColor?: string;
}

/**
 * BaseLayout - Common layout component for all pages
 * Provides consistent mobile-first design with proper utility classes
 */
const BaseLayout: React.FC<BaseLayoutProps> = ({ 
  children, 
  className = '', 
  style = {},
  enableSafeArea = true,
  backgroundColor = '#062475'
}) => {
  const baseClasses = `no-select full-height ${enableSafeArea ? 'safe-area-top' : ''} ${className}`.trim();
  
  const baseStyle: React.CSSProperties = {
    backgroundColor,
    position: 'relative',
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'SVN-Gilroy, Inter, Arial, sans-serif',
    overflow: 'hidden',
    ...style
  };

  return (
    <div className={baseClasses} style={baseStyle}>
      {children}
    </div>
  );
};

export default BaseLayout;
